import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useTabStyles } from "./styles";
import { TabsGlobalStyle } from "./tabs.styled";

interface TabComponentProps {
    idName: string; // The id for the container
    name: string; // The name of the tab container
    eventKeys: string[]; // Array of eventKeys to identify each tab
    tabPanes: React.ReactNode[]; // Array of React components for each Tab.Pane
    tabNames: string[];
}

const TabComponent: React.FC<TabComponentProps> = ({
    idName,
    name,
    eventKeys,
    tabPanes,
    tabNames
}) => {
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
    const handleTabSelect = (selectedKey: string | null) => {
        const index = eventKeys.indexOf(selectedKey || '');
        setSelectedTabIndex(index);
    };

    return (
        <div id={`${idName}-tabs-container`} className="ms-2 mt-3">
            <TabsGlobalStyle />
            <Tab.Container id={name} defaultActiveKey={eventKeys[0]} onSelect={handleTabSelect}>
                <Nav variant="underline" className="flex-row mb-4">
                    {eventKeys.map((key, index) => (
                        <Nav.Item key={key} className={`pe-3 border-end ${idName}-nav-item`}>
                            <Nav.Link eventKey={key} style={useTabStyles(selectedTabIndex === index)}>
                                {tabNames[index]}
                            </Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>

                <Tab.Content className="m-3">
                    {eventKeys.map((key, index) => (
                        <Tab.Pane eventKey={key} key={key}>
                            {selectedTabIndex === index && tabPanes[index]}
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};

export default TabComponent;